import { useState, useEffect } from "react";
import { SketchPicker } from "react-color";
import html2canvas from "html2canvas";
import compColors from "complementary-colors";
import "./App.css";
import HeaderProcess from "./components/HeaderProcess";
import logo from "./assets/logo.png";
import APONTANDO from "./assets/APONTANDO.png";
import Select from "react-select";
import Modal from 'react-bootstrap/Modal';

import { ReactComponent as Pincel } from "./icons/pincel.svg";
import { ReactComponent as Rolo } from "./icons/rolo.svg";
import { ReactComponent as Vetor } from "./icons/vetor.svg";
import { ReactComponent as Borracha } from "./icons/borracha.svg";
import { ReactComponent as Save } from "./icons/save.svg";
import { ReactComponent as Undo } from "./icons/undo.svg";
import { ReactComponent as Trash } from "./icons/trash.svg";
import { ReactComponent as EscondeCoresUsadas } from "./icons/escondeCoresUsadas.svg";
import { ReactComponent as MostraCoresUsadas } from "./icons/mostraCoresUsadas.svg";
import { ReactComponent as Confirmar } from "./icons/confirm.svg";
import {
  toolBruch,
  toolFill,
  toolVector,
  toolErase,
  relativePos,
  deltaE,
  fillVector,
  resetVector,
  undoChanges,
  rgbToHex,
  getCorProxima,
  toolTrash,
  minimizaCoresUsadas,
} from "./components/Tools";

function App() {
  const [selectedColor, setSelectedColor] = useState({});
  const [esconderCoresUsadas, setEsconderCoresUsadas] = useState(false);
  const [selectedTool, setSelectedTool] = useState(
    () => () => console.log("empty tool")
  );
  const [toolName, settoolName] = useState("empty");
  const [padraoCores, setPadraoCores] = useState([]);
  const [colorsUsed, setScolorsUsed] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchPickerResults, setSearchPickerResults] = useState([]);
  const [selectedPickerColor, setSelectedPickerColor] = useState();
  const [
    selectedPickerComplementaryColors,
    setSelectedPickerComplementaryColors,
  ] = useState([]);

  const [showSelectOption, setShowSelectOption] = useState(false);
  const options = [
    { value: "fachada", label: "Fachada", img: "fachada.png" },
    { value: "quarto", label: "Quarto", img: "quarto.png" },
    { value: "Sala", label: "Sala", img: "sala.png" },
    { value: "Cozinha", label: "Cozinha", img: "cozinha.png" },
  ];

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if ((/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent)) && !window.MSStream) {
      window.location.href = 'https://m.simuladorfutura.cloudtinting.com.br';
    }
  }, []);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const changeColor = (codigoCor, colorUsed, r, g, b) => {
    var canvas = document.getElementById("canvas");
    var context = canvas.getContext("2d");

    var color = colorUsed || `rgb(${r},${g},${b}, 1)`;
    context.fillStyle = color;
    context.strokeStyle = color;

    context.lineWidth = 10;

    setSelectedColor({ color, codigoCor });

    if (toolName === "toolPickColor") {
      let compColor = new compColors(rgbToHex(r, g, b)).complementary()[1];
      let tetradicColors = new compColors(rgbToHex(r, g, b)).tetradic();

      let coresCombinacao = getCorProxima(padraoCores, compColor).slice(0, 1);

      let tetradicColor1 = getCorProxima(padraoCores, tetradicColors[1]).slice(
        0,
        1
      )[0];
      let tetradicColor2 = getCorProxima(padraoCores, tetradicColors[2]).slice(
        0,
        1
      )[0];
      let tetradicColor3 = getCorProxima(padraoCores, tetradicColors[3]).slice(
        0,
        1
      )[0];

      coresCombinacao = [
        ...coresCombinacao,
        tetradicColor1,
        tetradicColor2,
        tetradicColor3,
      ];

      setSelectedPickerComplementaryColors(coresCombinacao);
    }

    var canvasRef = document.getElementById("canvasIMG");
    var contextRef = canvasRef.getContext("2d");

    contextRef.fillStyle = color;

    if (toolName === "toolFill") {
      toolFill();
    }
  };

  const changePickerColor = (color) => {
    setSelectedColor({ color });

    setSearchResults(
      padraoCores
        .map((padraoCor) => {
          padraoCor.deltaE = deltaE(
            [color.rgb.r, color.rgb.g, color.rgb.b],
            [padraoCor.r, padraoCor.g, padraoCor.b]
          );
          return padraoCor;
        })
        .sort((a, b) => a.deltaE - b.deltaE)
        .slice(0, 10)
    );
  };

  const canvasMouseDown = (event, onEnd) => {
    if (event.button === 0) {
      selectedTool(event, onEnd);
      event.preventDefault();
    }
  };

  const toolPickColor = (event) => {
    var canvas = document.getElementById("canvasIMG");
    var context = canvas.getContext("2d");

    try {
      var colorPos = relativePos(event, context.canvas);
      var imageData = context.getImageData(colorPos.x, colorPos.y, 1, 1);
      var colorVals = imageData.data;

      var color = "rgb(";

      for (var i = 0; i < colorVals.length - 1; i++) {
        if (colorVals[i] < 30) {
          color += 34;
        } else {
          color += colorVals[i];
        }
        if (i < 2) color += ",";
      }
      color += ")";

      context.fillStyle = color;
      context.strokeStyle = color;

      setSelectedColor({ color });

      var colorrgb = color
        .replace(/[^\d,]/g, "")
        .split(",")
        .map((num) => {
          return parseFloat(num);
        });

      var padraoMap = padraoCores
        .map((padraoCor) => {
          padraoCor.deltaE = deltaE(colorrgb, [
            padraoCor.r,
            padraoCor.g,
            padraoCor.b,
          ]);
          return padraoCor;
        })
        .sort((a, b) => a.deltaE - b.deltaE)
        .slice(0, 10);

      if (padraoMap.length > 0) {
        var firstColor = padraoMap.slice(0, 1)[0];

        var codigoCor = firstColor.codigo;
        color = `rgb(${firstColor.r},${firstColor.g},${firstColor.b}, 1)`;

        setSelectedColor({ color, codigoCor });
      }

      setSearchPickerResults(padraoMap);
    } catch (e) {
      throw e;
    }
  };

  const setActive = (event) => {
    var elems = document.querySelectorAll("div.ToolButton.active");
    [].forEach.call(elems, function (el) {
      el.classList.remove("active");
    });
    event.target.classList.add("active");
  };

  const toggleColorPicker = () => {
    var div = document.getElementById("picker");
    div.style.display = div.style.display === "flex" ? "none" : "flex";
  };

  const canvasClick = () => {
    if (
      toolName !== "toolPickColor" &&
      !colorsUsed.find((x) => x.color === selectedColor.color)
    ) {
      var colors = colorsUsed;
      colors.push(selectedColor);

      setScolorsUsed([...new Set(colors)]);
    }
  };

  const canvasMouseMove = (e) => {
    if (toolName === "toolPickColor") {
      var canvas = document.getElementById("canvasIMG");

      var context = canvas.getContext("2d");

      var colorPos = relativePos(e, context.canvas);
      const pixel = context.getImageData(colorPos.x, colorPos.y, 1, 1);
      const data = pixel.data;

      const rgba = `rgba(${data[0]}, ${data[1]}, ${data[2]}, ${data[3] / 255})`;

      var zoom = document.getElementById("zoomBox");
      var zoomContext = zoom.getContext("2d");
      zoomContext.fillStyle = rgba;

      zoomContext.fillRect(0, 0, zoom.width, zoom.height);

      var pagePos = relativePos(e, document.getElementById("desktop"));
      zoom.style.top = pagePos.y + 10 + "px";
      zoom.style.left = pagePos.x + "px";
      zoom.style.display = "block";
    }
  };

  const canvasMouseOut = () => {
    var zoom = document.getElementById("zoomBox");
    zoom.style.display = "none";
  };

  const colorFamilyClick = (familia) => {
    setSearchResults(
      padraoCores.filter((x) => x.familia?.toLowerCase() === familia)
    );
  };

  useEffect(() => {
    const protocol = window.location.protocol;
    fetch(`${protocol}//alessi.cloudtinting.com.br/api/padraocores`)
      .then((response) => response.json())
      .then((data) => {
        setPadraoCores(data.filter(x => x.r > 0 || x.g > 0 || x.b > 0));
      });
  }, []);

  useEffect(() => {
    const results = padraoCores.filter(
      (padraoCor) =>
        padraoCor.descricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
        padraoCor.codigo.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(results);
  }, [padraoCores, searchTerm]);

  const saveImage = () => {
    var showLogo = document.getElementById("logoImagem");
    showLogo.style.display = "block";

    var shadowDesktop = document.getElementById("desktop");
    shadowDesktop.style.boxShadow = "none";

    var shadowColors = document.getElementById("usedColors");
    shadowColors.style[""] = "none";
    shadowColors.style.boxShadow = "none";

    var tools = document.getElementById("tools");
    tools.style.display = "none";

    html2canvas(document.getElementById("desktop")).then((canvas) =>
      window.open(canvas.toDataURL("image/png"), "_blank")
    );
    showLogo.style.display = "none";
    tools.style.display = "block";

    shadowDesktop.style.boxShadow = "";
    shadowColors.style.boxShadow = "";
  };

  const selectStep2Change = (event) => {
    var canvas = document.getElementById("canvasIMG");
    var context = canvas.getContext("2d");

    var img = new Image();
    img.src = require("./assets/" + event.img);

    img.onload = () => {
      context.canvas.height = img.height;
      context.canvas.width = img.width;

      var style = window.getComputedStyle(canvas);
      context.canvas.height = style
        .getPropertyValue("height")
        .replace("px", "");
      context.canvas.width = style.getPropertyValue("width").replace("px", "");

      context.drawImage(img, 0, 0, context.canvas.width, context.canvas.height);

      canvas.style.background = `rgb(255, 255, 255, 1)`;
    };
  };

  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  return (
    <div className="App-Background">

      <div className="App-Header">
        <HeaderProcess
          setPickerSelectedTool={() => {
            settoolName("toolPickColor");
            setSelectedTool(() => toolPickColor);
          }}
          setSelectedTool={(tool) => setSelectedTool(() => tool)}
          selectedColor={selectedColor}
          settoolName={settoolName}
          setSelectedPickerColor={setSelectedPickerColor}
          setShowSelectOption={setShowSelectOption}
        />
      </div>

      <div className="App-Body">
        <div id="desktop" className="Desktop pt-3">
			<div id="logoImagem" className="LogoImagem">
            <img src={logo} width={150} height={60} alt="logo" />
          </div>

          {toolName !== "toolPickColor" && (
            <div className="AvisoCanvas" id="AvisoCanvas">
              CARREGUE UMA FOTO DE SUA PREFERÊNCIA
            </div>
          )}

          <canvas
            id="canvasIMG"
            className="CanvasIMG"
            width={600}
            height={600}
          ></canvas>

          <canvas
            id="canvas"
            className="Canvas"
            onClick={canvasClick}
            onMouseDown={canvasMouseDown}
            onMouseMove={canvasMouseMove}
            onMouseOut={canvasMouseOut}
          ></canvas>

          <canvas
            id="zoomBox"
            className="ZoomBox"
            width={60}
            height={60}
          ></canvas>

          {toolName !== "toolPickColor" && (
            <div id="usedColors" className="UsedColors">
              {colorsUsed.map((color, index) => (
                <div
                  key={index}
                  height="100px"
                  style={{ backgroundColor: color.color }}
                  title={color.codigoCor}
                  onClick={() => changeColor(color.codigoCor, color.color)}
                >
                  <span>{color.codigoCor}</span>
                </div>
              ))}
            </div>
          )}

          <div id="tools" className="Tools">
            <div
              className="SelectedColor"
              if="SelectedColor"
              style={{ backgroundColor: selectedColor.color || "transparent" }}
              title="Cor selecionada"
            ></div>

            <div className="ToolButton"
              id="toolPincel"
              onClick={(event) => {
                settoolName("toolBruch");
                setSelectedTool((event, onEnd) => toolBruch);
                setActive(event);
              }}>
              <Pincel />
              <label>PINCEL</label>
            </div>

            {<div className="ToolButton"
              onClick={(event) => {
                settoolName("toolFill");
                setSelectedTool((event, onEnd) => toolFill);
                setActive(event);
              }}>
              <Rolo />
              <label>PINTAR<br />ÁREA</label>
            </div>}

            <div className="ToolButton"
              onClick={(event) => {
                fillVector();
                resetVector();
                settoolName("toolVector");
                setSelectedTool((event, onEnd) => toolVector);
                setActive(event);
              }}>
              <Vetor
                id="vetor"
              />
              <label>SELECIONAR ÁREA</label>
              <div id="confirmarVetor" className="ConfirmarVetor"
                onClick={() => {
                  fillVector();
                  resetVector();
                }}>
                <Confirmar />
              </div>
            </div>

            <div className="ToolButton" onClick={undoChanges}>
              <Undo />
              <label>DESFAZER</label>
            </div>

            <div className="ToolButton"
              onClick={(event) => {
                settoolName("toolErase");
                setSelectedTool((event, onEnd) => toolErase);
                setActive(event);
              }}>
              <Borracha />
              <label>APAGAR ALTERAÇÕES</label>
            </div>
            <div className="ToolButton"
              onClick={() => {
                setScolorsUsed([]);
                toolTrash();
              }}>
              <Trash />
              <label>LIMPAR IMAGEM</label>
            </div>

            <div className="ToolButton" onClick={() => saveImage()} >
              <Save />
              <label>DOWNLOAD IMAGEM</label>
            </div>

            {esconderCoresUsadas ? (
              <div className="ToolButton"
                onClick={() =>
                  minimizaCoresUsadas(esconderCoresUsadas, setEsconderCoresUsadas)
                }>
                <MostraCoresUsadas
                  id="mostraCoresUsadas"
                />
                <label>MOSTRAR CORES</label>
              </div>
            ) : (
              <div className="ToolButton"
                onClick={() =>
                  minimizaCoresUsadas(esconderCoresUsadas, setEsconderCoresUsadas)
                }>
                <EscondeCoresUsadas
                  id="escondeCoresUsadas"
                />
                <label>ESCONDER CORES</label>
              </div>
            )}
          </div>
        </div>

        {toolName !== "toolPickColor" && (
          <div className="SearchColors" style={{ padding: '0 10px' }}>
              <p style={{ color: '#808080', textAlign: 'center', fontWeight: 'bolder', fontSize: '24px', marginTop: '3%', marginBottom: '1%'}}>CORES DISPONÍVEIS</p>
            {showSelectOption &&
              <>
                <label style={{ color: '#577d8e', width: '100%', fontWeight: 'bolder', fontSize: '16px', padding: '0 10px' }}>SELECIONE O AMBIENTE</label>
                <div style={{ color: '#577d8e', width: '90%', fontWeight: 'bolder', fontSize: '16px', padding: '0 10px', marginBottom: '25px' }}>
                  <Select
                    className="SelectBox"
                    id="selectAmbientes"
                    defaultValue={options[0]}
                    options={options}
                    onChange={(event) => selectStep2Change(event)}
                  />
                </div>
              </>
            }

            <label style={{ color: '#577d8e', width: '100%', fontWeight: 'bolder', fontSize: '16px', padding: '0% 5%' }}>DIGITE O CÓDIGO OU DESCRIÇÃO DA COR</label>
            <div className="SearchBox">
              <input
                type="text"
                value={searchTerm}
                onChange={handleChange}
              />
              {/* {<label
                className="SearchCancelButton"
                onClick={() => setSearchTerm("")}
              >X</label>} */}

              <div className="PickerButton" onClick={() => toggleColorPicker()}>
                MATIZ DE <br /> CORES
              </div>
            </div>

            <div className="ColorPicker" id="picker">
              <SketchPicker
                presetColors={[]}
                color={selectedColor.color}
                onChangeComplete={changePickerColor}
              />
              <button onClick={() => toggleColorPicker()} style={{ position: 'absolute', top: '5px', right: '5px', cursor: 'pointer' }}>
                X
              </button>
            </div>

            {padraoCores.length > 0 && (
				<div className="typeColorFamily">
					<input
						className="ColorFamily"
						type="button"
						id="Marrons"
						value="MARRONS"
						style={{ backgroundColor: '#CC6600', color: 'black', border: '2px solid #CC6600', borderRadius: '15px'}}
						onClick={() => colorFamilyClick("marrons")}
					/>
					<input
						className="ColorFamily"
						type="button"
						id="Verdes"
						value="VERDES"
						style={{ backgroundColor: '#c2dcd2', color: 'black', border: '2px solid #c2dcd2', borderRadius: '15px' }}
						onClick={() => colorFamilyClick("verdes")}
					/>
					<input
						className="ColorFamily"
						type="button"
						id="RosasRoxos"
						value="ROSAS E ROXOS"
						style={{ backgroundColor: '#FF33FF', color: 'black', border: '2px solid #FF33FF', borderRadius: '15px'}}
						onClick={() => colorFamilyClick("rosas e roxos")}
					/>
					<input
						className="ColorFamily"
						type="button"
						id="Azuis"
						value="AZUIS"
						style={{ backgroundColor: '#3333FF', color: 'black', border: '2px solid #3333FF', borderRadius: '15px' }}
						onClick={() => colorFamilyClick("azuis")}
					/>
					<input
 						className="ColorFamily"
 						type="button"
 						id="LaranjasVermelhos"
 						value="VERMELHOS"
 						style={{ backgroundColor: '#FF3333', color: 'black', border: '2px solid #FF3333', borderRadius: '15px' }}
						onClick={() => colorFamilyClick("laranjas e vermelhos")}
					/>
					<input
				 		className="ColorFamily"
				 		type="button"
				 		id="Amarelos"
				 		value="AMARELOS"
				 		style={{ backgroundColor: '#FFFF66', color: 'black', border: '2px solid #FFFF66', borderRadius: '15px' }}
						onClick={() => colorFamilyClick("amarelos")}
					/>
				</div>
            )}

            <div className={"ScrollColors " + (showSelectOption ? 'showSelectOption' : '')}>
              {searchResults.length === 0
                ? searchTerm === ""
                  ? "Carregando..."
                  : "Nenhum registro encontrado."
                : searchResults.map((padraoCor) => (
                  <div
                    className="ColorSquare"
                    style={{
                      backgroundColor: `rgb(${padraoCor.r}, ${padraoCor.g}, ${padraoCor.b})`,
                    }}
                    key={padraoCor.id.toString()}
                    onClick={() =>
                      changeColor(
                        padraoCor.codigo,
                        null,
                        padraoCor.r,
                        padraoCor.g,
                        padraoCor.b
                      )
                    }
                  >
                    <div className="ColorLabel">
                      {padraoCor.codigo} <br /> {padraoCor.descricao}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}

        {toolName === "toolPickColor" && !selectedPickerColor && (
          <div className="SearchColors">
            <div className="ScrollColors ScrollColorsPicker">
              {searchPickerResults.length === 0 ? (
                <div style={{ marginTop: "15px" }}>
                  Capture a cor na imagem carregada
                </div>
              ) : (
                <div style={{ margin: "15px", width: '100%', textAlign: "center" }}>
                  <label style={{ color: '#577d8e', width: '100%', fontWeight: 'bolder', fontSize: '16px', padding: '0px 10px' }}>CORES DISPONÍVEIS</label>
                </div>
              )}
              {searchPickerResults.slice(0, 1).map((padraoCor) => (
                <div
                  className="ColorSquare ColorSquareFirst"
                  style={{
                    backgroundColor: `rgb(${padraoCor.r}, ${padraoCor.g}, ${padraoCor.b})`,
                  }}
                  key={padraoCor.id.toString()}
                  onClick={() => {
                    setSelectedPickerColor(padraoCor);
                    changeColor(
                      padraoCor.codigo,
                      null,
                      padraoCor.r,
                      padraoCor.g,
                      padraoCor.b
                    );
                  }}
                >
                  <div className="ColorLabel">
                    {padraoCor.codigo} <br /> {padraoCor.descricao}
                  </div>
                </div>
              ))}
              {searchPickerResults.slice(1).map((padraoCor) => (
                <div
                  className="ColorSquare"
                  style={{
                    backgroundColor: `rgb(${padraoCor.r}, ${padraoCor.g}, ${padraoCor.b})`,
                  }}
                  key={padraoCor.id.toString()}
                  onClick={() => {
                    setSelectedPickerColor(padraoCor);
                    changeColor(
                      padraoCor.codigo,
                      null,
                      padraoCor.r,
                      padraoCor.g,
                      padraoCor.b
                    );
                  }}
                >
                  <div className="ColorLabel">
                    {padraoCor.codigo} <br /> {padraoCor.descricao}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {selectedPickerColor && (
          <div className="SearchColors">
            <div
              className="BotaoVoltar"
              title="Voltar"
              onClick={() => setSelectedPickerColor()}
            >
              <span className="SetaVoltar"></span>
            </div>
            <div style={{ marginBottom: "15px", width: '100%', textAlign: "center" }}>
              <label style={{ color: '#577d8e', width: '100%', fontWeight: 'bolder', fontSize: '16px', padding: '0px 10px' }}>COMBINAÇÃO DE CORES</label>
            </div>
            <div className="ScrollColors ScrollColorsPicker">
              <div
                className="ColorSquare ColorSquareFirst"
                style={{
                  backgroundColor: `rgb(${selectedPickerColor.r}, ${selectedPickerColor.g}, ${selectedPickerColor.b})`,
                }}
                key={selectedPickerColor.id.toString()}
              >
                <div className="ColorLabel">
                  {selectedPickerColor.codigo} <br />{" "}
                  {selectedPickerColor.descricao}
                </div>
              </div>

              {selectedPickerComplementaryColors.map((padraoCor) => (
                <div
                  className="ColorSquare"
                  style={{
                    backgroundColor: `rgb(${padraoCor.r}, ${padraoCor.g}, ${padraoCor.b})`,
                  }}
                  key={padraoCor.id.toString()}
                >
                  <div className="ColorLabel">
                    {padraoCor.codigo} <br /> {padraoCor.descricao}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
